import React from "react";
import UserAdminView from "./UserAdminView";

const UserAdminApplication = () => {
  return <UserAdminView />;
};

export default UserAdminApplication;
